var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useResultCategoryOutletContext } from '@/components/results-category/hooks/use-result-category-outlet-context.hook';
import { HearingResultsPopup } from '@/components/results-category/components/hearing-results-popup.component';
import { Typography } from '@mui/material';
import { EargoButton } from '@/components/eargo-button.component';
import { ContentBlock } from '@/components/results-category/components/content-block.component';
import { supportContactInformation } from '@/constants/support.constant';
function Heading() {
    return (_jsxs("span", __assign({ className: 'inline-block leading-10 text-center md:w-full max-w-2xl font-normal' }, { children: ["Your hearing test results show that you have", ' ', _jsx("span", __assign({ className: 'font-extrabold text-eargo-fern-green' }, { children: "normal hearing." }))] })));
}
export function NormalHearingLossResults() {
    useResultCategoryOutletContext({
        heading: _jsx(Heading, {}),
        step: 2,
    });
    return (_jsxs("div", __assign({ className: 'h-full flex flex-col gap-y-10 px-4 md:px-10 md:-mt-12' }, { children: [_jsx(HearingResultsPopup, {}), _jsxs(ContentBlock, { children: [_jsx(Typography, __assign({ className: 'text-lg w-full font-bold' }, { children: "Still have questions about your hearing health? Our team is here to support." })), _jsx(EargoButton, __assign({ className: 'text-white bg-eargo-sinopia rounded-full w-full md:w-1/2 items-center py-3', fullWidth: true, href: supportContactInformation.phone.href, target: "_blank" }, { children: "Speak to our team" }))] }), _jsx(EargoButton, __assign({ variant: 'outlined', className: 'rounded-full w-full md:w-1/2 items-center py-3 self-center', fullWidth: true, href: 'https://www.eargo.com/blog', target: '_blank' }, { children: "Learn more about hearing health" }))] })));
}
